import { UserProfile, Recipe, IngredientDetail, ShoppingItem, ScheduleByDate, UserInventory } from '../types';

export const initialUserProfile: UserProfile = {
  id: "",
  name: "",
  email: "",
  level: 1,
  xp: 0,
  maxXp: 500,
  theme: 'light',
  joinedDate: "",
  favoriteRecipeIds: [],
  favoriteIngredientIds: [],
  goals: {
    height: 0,
    weight: 0,
    targetCalories: 2000,
    targetProtein: 0,
    targetFat: 0,
    targetCarbs: 0,
    targetFiber: 0
  },
  allergies: [],
  dietaryRestrictions: [],
  recipeRatings: {}
  };

export const initialRecipes: Recipe[] = [];

export const initialIngredients: IngredientDetail[] = [];

export const initialUserInventory: UserInventory = {};

export const initialScheduleByDate: ScheduleByDate = {};

export const initialShoppingList: ShoppingItem[] = [];
